import { RoleType, UserLoginType } from "@/DTO";
import { Api } from "@/api";

export const GetCaptcha = () => {
  return new Promise<{
    id: string
    captcha: string
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `captcha`,
      header: {
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          id: data.data.id,
          captcha: data.data.captcha
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const SendOtp = (phone: string, captchaId: string, captchaText: string) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "post",
      path: `otp/send`,
      body: JSON.stringify(
        {
          phone: phone,
          captcha_id: captchaId,
          captcha_text: captchaText
        }
      ),
      header: {
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const CheckOtp = (phone: string, otp: string) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "post",
      path: `admin/login-otp`,
      body: JSON.stringify(
        {
          phone: phone,
          password: otp
        }
      ),
      header: {
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToUserType(data.data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const FetchUserLogin = (phone: string, password: string) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "post",
      path: `admin/login`,
      body: JSON.stringify(
        {
          phone: phone,
          password: password
        }
      ),
      header: {
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToUserType(data.data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const FetchByRefreshToken = (user: UserLoginType) => {
  return new Promise<{
    data: UserLoginType;
  }>((resolve, reject) => {
    const api = new Api({
      method: "post",
      path: "admin/refreshToken",
      header: {
        Authorization: "Bearer " + user.refreshToken
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToUserType({
            ...data.data,
            refreshToken: user.refreshToken
          })
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export function ConvertToUserType(item: any): UserLoginType {
  const returnUser = {
    accessToken: item?.accessToken,
    refreshToken: item?.refreshToken,
    id: item.id,
    phone: item.phone,
    first_name: item.first_name,
    last_name: item.last_name,
    status: item.status,
    created_at: item.created_at,
    role: item.role ? ConvertToRoleListType(item.role) : [],
    permission_list: item.permission_list ? item.permission_list : []
  };
  return returnUser;
}

export function ConvertToRoleListType(data: any[]): RoleType[] {
  return data.map((item) => ConvertToRoleType(item));
}

export function ConvertToRoleType(item: any): RoleType {
  return {
    id: item.id,
    title: item.title
  };
}
